import {Injectable} from "@angular/core";
import { App, Platform, Events } from 'ionic-angular';

import {TeamappProvider} from './teamapp';
import {UserProvider} from './user';
import {DataProvider} from './data';

/* Types Pages */
import { MessagecenterPage } from '../pages/messagecenter/messagecenter';
import { TabsPage } from '../pages/tabs/tabs';
import { WallPage } from '../pages/wall/wall';
import { ChatPage } from '../pages/chat/chat';
import { NewsPage } from '../pages/news/news';

@Injectable()
export class MessageProvider {
    firebasePlugin: any;

    groupList: any;
    groupsInfo: any;
    unreadGroupMessagesCount: number = 0;

    conversationsInfo: any;
    conversationList: any;
    unreadMessagesCount: number = 0;

    listenToChatStarted: boolean = false;
    // Data Provider
    // This is the provider class for most of the Firebase observables in the app.

    constructor(public events: Events, public dataProvider: DataProvider, public app: App, public teamappProvider: TeamappProvider, public userProvider: UserProvider, private platform: Platform) {

    }

    startSubscribe() {
        let that = this;
        setInterval(function(){
            that.getCount();
        },15000);
    }

    getCount() {
        this.teamappProvider.http_request('action=get_count', 'messages', false, false).then(data => {
            let countData: any = data;
            console.log(data);
            if(!countData.error) {
                this.userProvider.setUserMessageCount(countData.count);
                this.userProvider.setUserChatCount(countData.count_chat);
            }
        });
    }

    onMessageReceived(data){
        console.log("------ MESSAGE!");
        console.log(data);
        if(data.tap == "background") {
            if(data.type == 'messages') {
                this.app.getRootNav().push(MessagecenterPage);
            } else if(data.type == 'group') {
                this.app.getRootNav().push(TabsPage, {open: 1});
            } else if(data.type == 'chat') {
                this.app.getRootNav().push(ChatPage);
            } else if(data.type == 'friend') {
                this.app.getRootNav().push(TabsPage, {open: 2});
            } else if(data.type == 'wall') {
                this.app.getRootNav().push(WallPage);
            } else if(data.type == 'news') {
                this.app.getRootNav().push(NewsPage);
            }
        }
    }

    startListen() {
        this.platform.ready().then(() => {
            if(this.platform.is('cordova')) {
                this.firebasePlugin = (<any>window).FirebasePlugin;
                this.firebasePlugin.onMessageReceived(this.onMessageReceived.bind(this));
            }
        });
    }

    /*Message Counter*/
    getConversions() {


    }

    addOrUpdateGroup(group) {
        if (!this.groupList) {
            this.groupList = [group];
        } else {
            var index = -1;
            for (var i = 0; i < this.groupList.length; i++) {
                if (this.groupList[i].$key == group.$key) {
                    index = i;
                }
            }
            if (index > -1) {
                this.groupList[index] = group;
            } else {
                //this.groupList.push(group);
            }
        }
        this.computeUnreadGroupMessagesCount();
    }

    addOrUpdateConversation(conversation) {
        if (!this.conversationList) {
            this.conversationList = [conversation];
        } else {
            var index = -1;
            for (var i = 0; i < this.conversationList.length; i++) {
                if (this.conversationList[i].$key == conversation.$key) {
                    index = i;
                }
            }
            if (index > -1) {
                this.conversationList[index] = conversation;
            } else {
                //this.conversationList.push(conversation);
            }
        }
        this.computeUnreadMessagesCount();
    }

    computeUnreadMessagesCount() {
        this.unreadMessagesCount = 0;
        if (this.conversationList) {
            for (var i = 0; i < this.conversationList.length; i++) {
                this.unreadMessagesCount += this.conversationList[i].messages.length - this.conversationsInfo[i].messagesRead;
                if (this.unreadMessagesCount == 0) {
                    this.unreadMessagesCount = 0;
                }
            }
        }
        this.publishMessagesCount();
    }

// Compute all group's unreadMessages.
    computeUnreadGroupMessagesCount() {
        this.unreadGroupMessagesCount = 0;
        if (this.groupList) {
            for (var i = 0; i < this.groupList.length; i++) {
                if (this.groupList[i].messages) {
                    this.unreadGroupMessagesCount += this.groupList[i].messages.length - this.groupsInfo[i].messagesRead;
                }
                if (this.unreadGroupMessagesCount == 0) {
                    this.unreadGroupMessagesCount = null;
                }
            }
        }
        this.publishMessagesCount();
    }

    getUnreadMessagesCount() {
        if (this.unreadMessagesCount) {
            if (this.unreadMessagesCount > 0) {
                return this.unreadMessagesCount;
            }
        }
        return 0;
    }

    publishMessagesCount() {
        let mC = this.unreadMessagesCount+this.unreadGroupMessagesCount;
        this.events.publish('chat:updatecount', mC);
    }

    getChatMessageCount() {
        return this.unreadMessagesCount+this.unreadGroupMessagesCount;
    }

}



// WEBPACK FOOTER //
// ./src/providers/message.ts